import React from 'react';
import './AppNavBar.css';
import { IonButton } from '@ionic/react';
import { useHistory } from 'react-router';

type AppNavBarProps = {
  items: any[];
  selected: number;
};

export default function AppNavBar({ items, selected }: AppNavBarProps) {

  const router = useHistory();

  return (
    <div className="app-nav-bar">
      {items.map((item: any, index: number) => {
        return (
          <IonButton
            fill={index != selected ? 'clear' : 'solid'}
            strong={index != selected}
            key={index}
            onClick={() => router.push(item.url)}
          >
            {item.label}
          </IonButton>
        );
      })}
    </div>
  );
}
